import { gql } from '@apollo/client';
import { COMPANY_FRAGMENT, COMPANY_DESIGN_FRAGMENT } from 'graphql/secure/fragments';

export const GET_COMPANY_DETAILS = gql`
  query GetCompanyDetails {
    company {
      ...companyValues
    }
  }
  ${COMPANY_FRAGMENT}
`;

export const GET_COMPANY_DESIGN = gql`
  query GetCompanyDetails {
    company {
      id
      design {
        ...companyDesignValues
      }
    }
  }
  ${COMPANY_DESIGN_FRAGMENT}
`;

export const GET_FONTS = gql`
  query GetFonts {
    getFonts @client(always: true) {
      fontNames
    }
  }
`;

export const GET_INTEGRATION_SETTINGS = gql`
  query IntegrationSettings {
    company {
      id
      apiKey
      mapboxApiToken
      integrationSettings {
        widgetType
        showClaims
      }
    }
  }
`;

export const IS_EXTERNAL_ID_AVAILABLE = gql`
  query IsExternalIdAvailable(
    $model: String!
    $externalId: String!
    $filters: ExternalIdAvailabilityFilters!
  ) {
    isExternalIdAvailable(model: $model, externalId: $externalId, filters: $filters)
  }
`;
